<template>
    <div class="na-form">
        <div class="staBtTitle">
            <div class="staTitle col">Import History</div>
        </div>

        <div v-if="loadError" style="color: red; margin-bottom: 12px;">
            {{ loadError }}
        </div>

        <DxDataGrid
            :data-source="batches"
            :show-borders="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            @row-click="onRowClick">

            <DxColumn data-field="IbId" caption="Id" :width="80" alignment="right" />
            <DxColumn data-field="IbCreatedOn" caption="Created On" data-type="datetime" format="dd.MM.yyyy HH:mm" />
            <DxColumn data-field="IbCreatedBy" caption="Created By" />
            <DxColumn data-field="IbFileId" caption="File" />
            <DxColumn data-field="IbStatus" caption="Status" cell-template="statusTemplate" />
            <DxColumn data-field="IbRowCount" caption="Rows" alignment="right" />
            <DxColumn data-field="NewRowCount" caption="New" alignment="right" />
            <DxColumn data-field="UpdateRowCount" caption="Updates" alignment="right" />
            <DxColumn data-field="ErrorRowCount" caption="Errors" alignment="right" cell-template="errorCountTemplate" />
            <DxColumn data-field="IbUndoneOn" caption="Undone On" data-type="datetime" format="dd.MM.yyyy HH:mm" />

            <template #statusTemplate="{ data }">
                <span :style="statusStyle(data.value)">{{ data.value }}</span>
            </template>

            <template #errorCountTemplate="{ data }">
                <span :style="data.value > 0 ? 'color: red; font-weight: 600;' : ''">{{ data.value }}</span>
            </template>

        </DxDataGrid>
    </div>
</template>

<script>
import axios from 'axios'
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid'

export default {
    name: 'ImportHistoryVx',
    components: {
        DxDataGrid,
        DxColumn
    },
    data() {
        return {
            batches: [],
            loadError: null
        }
    },
    created() {
        axios.get('WebApi.asmx/api/topicImportService/getImportBatches')
            .then(res => {
                if (res.data && res.data.success) {
                    this.batches = res.data.data.batches || []
                } else {
                    this.loadError = (res.data && res.data.errorMessage) || 'Failed to load import batches'
                }
            })
            .catch(err => {
                this.loadError = 'Failed to load import batches: ' + (err.message || err)
            })
    },
    methods: {
        onRowClick(e) {
            if (e && e.data && e.data.IbId) {
                this.$router.push({ name: 'ImportHistoryDetailVx', params: { ibId: String(e.data.IbId) } })
            }
        },
        statusStyle(status) {
            switch (status) {
                case 'Success':  return 'color: #155724; background: #d4edda; padding: 2px 8px; border-radius: 4px;'
                case 'Partial':  return 'color: #856404; background: #fff3cd; padding: 2px 8px; border-radius: 4px;'
                case 'Failed':   return 'color: #721c24; background: #f8d7da; padding: 2px 8px; border-radius: 4px;'
                case 'Undone':   return 'color: #383d41; background: #e2e3e5; padding: 2px 8px; border-radius: 4px;'
                default:         return 'padding: 2px 8px;'
            }
        }
    }
}
</script>

<style scoped>
.na-form {
    padding: 16px;
}
</style>
